"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Dashboard;

var _Dashboard = require("@adobe/react-spectrum-workflow/dist/Dashboard");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Dashboard(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Dashboard.A4uDashboard, null));
}